<template>
  <div>
    <Modal class="editBlock modalqkmsg" v-model="modal" title="新增问答" width="45" footer-hide>
      <div class="bodyhigh">
        <div class="bodytwice">
          <div class="content">
            <Row>
              <Col :xs="{span:24}" :lg="{span:12}">
                <label>标题</label>
                <Input class="editInput" v-model="qkmsgTitle" type="text"></Input>
              </Col>
              <Col :xs="{span:24}" :lg="{span:12}" class="clas">
                <label>分类</label>
                <div style="display:inline">
                  <Select v-model="qkmsgClas" :transfer="true">
                    <Option
                      v-for="(item,idx) in clasArr"
                      :value="item.gupid"
                      :key="idx"
                    >{{item.gupname}}</Option>
                  </Select>
                </div>
              </Col>
            </Row>
            <div class="bodytwice-bottom">
              <label class="qkmsgContentLabel">内容</label>
              <Input
                class="qkmsgContent"
                type="textarea"
                v-model="qkmsgcontent"
                :autosize="{minRows: 5,maxRows: 5}"
              ></Input>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body-footer">
        <div class="btngp">
          <div class="btn" @click="addConfirm">提交</div>
          <div class="btn" @click="reset">重置</div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: "ModalQkmsg",
  props: {
    qkmsgstatus: {
      type: Boolean,
      required: true
    },
    clasArr: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      qkmsgTitle: "",
      qkmsgClas: "",
      qkmsgcontent: "",
      clasName: "",
      clas: []
    }
  },
  computed: {
    ...mapGetters(["username"]),
    modal: {
      get () {
        return this.qkmsgstatus
      },
      set (val) {
        this.reset()
        this.$emit("update:qkmsgstatus", val)
      }
    }
  },
  methods: {
    //提交确定
    addConfirm () {
      if (
        !this.qkmsgTitle ||
        !this.qkmsgClas ||
        !this.qkmsgcontent
      ) {
        this.$Message.error('每个栏位皆需填入内容');
      }
      let obj = {
        maid: Number(this.username.maid),
        clas: this.qkmsgClas,
        title: this.qkmsgTitle,
        innertext: this.qkmsgcontent
      };
      this.$axios
        .qkmsgins(obj)
        .then(res => {
          this.$emit("getQkmsg")
          this.reset()
        })
        .catch(err => console.error(err))
      this.modal = false
    },
    //reset
    reset () {
      this.qkmsgcontent = ""
      this.qkmsgTitle = ""
      this.qkmsgClas = ""
    }
  }
}
</script>
<style lang="less">
.modalqkmsg {
  .ivu-input {
    height: 40px;
  }
  .ivu-select {
    width: 75%;
    margin-left: 10px;
    position: static;
  }
  .ivu-select-selection {
    height: 40px;
    .ivu-select-placeholder,
    .ivu-select-selected-value {
      line-height: 40px;
    }
  }
  .clas {
    margin-bottom: 0;
    transform: translateY(7px);
  }
  .qkmsgContent {
    margin-left: 10px;
  }
  .qkmsgContentLabel {
    display: inline-block;
    transform: translateY(-40px);
  }
  .qkmsgContent {
    width: 88%;
  }
}
@media screen and (max-width: 992px) {
  .modalqkmsg {
    .ivu-modal-body .bodytwice .content {
      padding-left: 10px;
      padding-right: 10px;
    }
    .editInput {
      width: 83%;
    }
    .clas {
      width: 111%;
    }
    .bodytwice-bottom {
      margin-top: 20px;
      .qkmsgContent {
        width: 83%;
      }
    }
  }
}
</style>